import Vue from 'vue';

const success = (context, response) => {
  let messagesSms = response.data.messages;

  function sortBy(array) {
    let filterA, filterB;
    return array.sort(function (a, b) {
      filterA = a.created_at;
      filterB = b.created_at;
      return (filterA < filterB) ? 1 : -1;
    })
  }

  messagesSms = sortBy(messagesSms);
  context.messagesSms = messagesSms;
};

const failed = (context, error) => {
  context.showToasterError(error);
};

export default (context) => {
  return Vue.$http.get('messages/sms-sent')
         .then(response => {
            if(response.status === 200) {
              success(context, response);
            }
         }).catch(error => {
             failed(context, error);
         })
}



// WEBPACK FOOTER //
// ./src/app/services/message/getSmsSent.js